import React,{useState} from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import CommunicationsTable from "./CommunicationsTable";
import CampaignsTable from "../CampaignComponents/CampaignsTable";
import "./MyContentTabs.css";

const MyContentTabs = () => { 
  const [value, setValue] = useState("1");
  const [l1,setL1]= useState("Communications"); // level 1 sub-header
  const [l2, setL2]= useState(""); // level 2 sub-header
  const handleChange = (event, newValue) => {
    setL2("");
    setValue(newValue);   
    if(newValue == 1){
      setL1("Communications");
  }else if(newValue == 2){
    setL1("Campaigns");
  }
  };

  return (
    <><WelcomeNameContainer currentComp="mycontent" l1={l1} l2={l2}/>  
      <div className="admintabs-container">
        {/* <Box sx={{ width: "95%", typography: "body1", margin: "auto" }}> */}
        <TabContext value={value}>
          {l2==="" &&
           <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              sx={{
                backgroundColor: "f0f4ff",
              }}
            >
              <Tab
                label="Communications"
                value="1"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                }}
              />

              <Box
                sx={{
                  width: "0.5px",
                  height: "24px",
                  backgroundColor: "gray",
                  mx: 1,
                  marginTop: "12px",
                }}
              />

              <Tab
                label="Campaigns"
                value="2"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                }}
              />

            </TabList>
          </Box>
           }
          <TabPanel value="1">
                <CommunicationsTable setL2={setL2}/>
          </TabPanel>
          <TabPanel value="2">
                <CampaignsTable  approvalView={false} setL2={setL2}/>
          </TabPanel>
 
        </TabContext>
        {/* </Box> */}
      </div>
    </>
  );
};

export default MyContentTabs;
